export const caches = {};


// WEBPACK FOOTER //
// ./src/utils/caches.js